import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { IconChevron } from '../../../../../../../assets/icons/icon-chevron';

type ExportButtonProps = {
  handleExport: () => Promise<void>;
  disabled: boolean;
};

export const ExportButton: React.FC<ExportButtonProps> = ({ handleExport, disabled }) => {
  const { t } = useTranslation('common');

  return (
    <Button
      sx={{
        textTransform: 'none',
        backgroundColor: 'var(--color-background)',
        color: 'var(--color-type-primary)',
        borderRadius: '8px',
        fontWeight: 600,
        marginTop: 5,
      }}
      onClick={handleExport}
      disabled={disabled}
    >
      {t('exportToCsv')}
      <IconChevron direction="down" />
    </Button>
  );
};
